import { TPost } from "../../types/Post";
const postHasNoProducts = (post: TPost) => {
	return !post.items?.length;
};
const postIsOfTypeRepost = (post: TPost) => {
	const { type } = post;
	const repostType = ['galleryPost', 'videoPost'];
	return repostType.includes(type);
};

export const canProceedToModifyPost = (post: TPost) => {
	return postHasNoProducts(post) &&
		postIsOfTypeRepost(post)
		;
};
